import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { ApiRequest } from 'GlobalFunctions';

export default function AutocompleteParentProducts(props: any) {

  const {value, onChange, error} = props;
  const [list, setList] = useState<any []>([]);

  useEffect(() => {
    loadList();
  }, []);

  const loadList = async () => {
    await ApiRequest({
      url: "/product_parents/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        full_list: true,
      },
      setResponse: (response: any) => {
        setList(response.list);
      },
    });
  }

  let item_name: any = null;
  if (list && value && value != 0) {
    item_name = list.find(obj => obj.parent_product_id === parseInt(value)) || null;
  }

  return (
    <>
      {list.length > 0 ? (
        <Autocomplete
          value={item_name}
          onChange={(event, newValue) => {
            onChange({
              target: {
                value: newValue ? newValue.parent_product_id.toString() : "",
                name: "product_id",
              }
            });
          }}
          fullWidth
          options={list}
          getOptionLabel={(option) => option.parent_product_name || ""}
          renderOption={(props, option) => (
            <li className="flex_select" {...props} key={option.parent_product_id}>
              <div className="flex_option_1">{option.parent_product_name}</div>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Producto padre"
              error={error}
              placeholder='Producto padre'
            />
          )}
        />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}
